export enum Environment {
    DEV = 'DEV',
    TEST = 'TEST',
    PROD = 'PROD'
}

export const getEnvironment = (): Environment => {
    const { hostname } = window.location;
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        return Environment.DEV;
    }
    if (hostname.includes('test')) {
        return Environment.TEST;
    }
    return Environment.PROD;
};

export const getContributorsDashboardUrl = (): string => {
    const env = getEnvironment();
    switch (env) {
        case Environment.DEV:
            return 'http://localhost:3000';
        case Environment.TEST:
            return 'https://app.test.bh.caas.ai/';
        case Environment.PROD:
        default:
            return 'https://app.caas.ai/';
    }
};
